import React from 'react';

import {GridCard} from 'src/components/editorial';

import {SanityEditorial, Maybe} from 'types/generated';

type ThreeGridArticlesProps = {
  heading?: Maybe<string>;
  articleOne: Maybe<SanityEditorial>;
  articleTwo: Maybe<SanityEditorial>;
  articleThree: Maybe<SanityEditorial>;
};

export const ThreeGridArticles: React.FC<ThreeGridArticlesProps> = (props: ThreeGridArticlesProps) => (
  <section className="px-gutter bg-green-dark module-spacing" data-module="trending-now">
    <div className="wrapper-default grid grid-cols-4 sm:grid-cols-12 sm:gap-x-8 gap-y-7">
      <h2 className="type-beta text-white lg:mb-11 col-span-full text-center">{props.heading}</h2>

      <GridCard
        cardColClasses={'"grid col-span-full sm:col-span-4 gap-x-4 items-center md:items-start content-start'}
        title={props.articleOne?.title}
        category={props.articleOne?.category || ''}
        image={props.articleOne?.heroImage}
        imageClasses={'grid col-span-full pb-[68%] lg:h-[275px]'}
        contentClasses={'col-span-full mt-4 lg:mt-7 text-white'}
        titleClasses={'type-eta text-white link-text-white'}
        eyebrowClasses={'block type-eyebrow mb-2 text-white'}
        slug={props.articleOne?.slug?.current || ''}
        editorialCategory={props.articleOne?.editorialCategory}
        isPodcast={props.articleOne?.isPodcast}
      />

      <GridCard
        cardColClasses={'"grid col-span-full sm:col-span-4 gap-x-4 items-center md:items-start content-start'}
        title={props.articleTwo?.title}
        category={props.articleTwo?.category || ''}
        image={props.articleTwo?.heroImage}
        imageClasses={'grid col-span-full pb-[68%] lg:h-[275px]'}
        contentClasses={'col-span-full mt-4 lg:mt-7 text-white'}
        titleClasses={'type-eta text-white link-text-white'}
        eyebrowClasses={'block type-eyebrow mb-2 text-white'}
        slug={props.articleTwo?.slug?.current || ''}
        editorialCategory={props.articleTwo?.editorialCategory}
        isPodcast={props.articleTwo?.isPodcast}
      />

      <GridCard
        cardColClasses={'"grid col-span-full sm:col-span-4 gap-x-4 items-center md:items-start content-start'}
        title={props.articleThree?.title}
        category={props.articleThree?.category || ''}
        image={props.articleThree?.heroImage}
        imageClasses={'grid col-span-full pb-[68%] lg:h-[275px]'}
        contentClasses={'col-span-full mt-4 lg:mt-7 text-white'}
        titleClasses={'type-eta text-white link-text-white'}
        eyebrowClasses={'block type-eyebrow mb-2 text-white'}
        slug={props.articleThree?.slug?.current || ''}
        editorialCategory={props.articleThree?.editorialCategory}
        isPodcast={props.articleThree?.isPodcast}
      />
    </div>
  </section>
);
